






































import { Vue, Component, Prop } from 'vue-property-decorator';

import { Setting as terms } from '@/const/terms/mainTerms';
import { ComponentTerms as compTerms } from '@/const/terms/componentTerms';

import { IInventory } from '@/pages/campaign/adset/editingTypes';
import { CampaignInfoResponse } from '@/pages/campaign/editingTypes';

import PriceBrief from '@/components/ElementComponent/Brief/PriceBrief.vue';
import NumberInput from '@/components/ElementComponent/Input/NumberInput.vue';

import { ORIGIN_FORMAT } from '@/utils';
import { SummaryMethodParams } from 'element-ui/types/table';

@Component<AdsetTableOfBudget>({
    name: 'AdsetTableOfBudget',
    components: {
        PriceBrief,
        NumberInput, 
    },
})
export default class AdsetTableOfBudget extends Vue {
    @Prop({ type: Array, required: true }) private value!: IInventory[];
    @Prop({ type: Object, required: true }) private campaignData!: CampaignInfoResponse;
    
    get targets() { return this.value }
    set targets(v: IInventory[]) { this.$emit('input', v) }

    private terms = terms;
    private compTerms = compTerms;

    private budgetToApply: number = 0;
    private budgetSelected: IInventory[] = [];
    
    private budgetRowSelectedHandler(val: IInventory[]) {this.budgetSelected = val}
    private setBudgetToSelected() {
        const v = this.budgetToApply;
        this.budgetSelected.forEach((item: IInventory) => {item.budget = v});
    }

    private handleBudgetSummary(param: SummaryMethodParams) {
        const { columns, data } = param as {columns: any[], data: IInventory[]};
        const sums = [] as string[];
        columns.forEach((column: any, index: number) => {
            
            if (column.label === this.compTerms.form.adset.budget.column.name) {
                if (this.campaignData.budget.limited) {
                    sums[index] =  `${this.terms.campaign.default} ${this.campaignData.budget.type === 'total' ? '총' : '일'} 예산 : ${ORIGIN_FORMAT.NumberFormatOrigin(this.campaignData.budget.value)} 원`;
                } else {
                    sums[index] = `${this.terms.campaign.default} ${this.campaignData.budget.type === 'total' ? '총' : '일'} 예산 : 무제한`;
                }
                return;
            } else if (column.label === this.compTerms.form.adset.budget.column.value) {
                sums[index] = `${this.terms.inventory.default} 예산 총합 : `

            } else if (column.label === this.compTerms.form.adset.budget.column.valuePresenting) {
                const num = this.targets.reduce((pre: number, item: IInventory) => {
                    return pre + item.budget;
                }, 0)
                sums[index] = ORIGIN_FORMAT.NumberFormatOrigin(num) + ' 원';
            }
        });
        return sums;
    }
}
